/**
 * Format a license plate for display: xx-xxx-xx (7 digits) or xxx-xx-xxx (8 digits).
 * @param {string} plate - Raw plate (e.g. "1234567" or "12-345-67")
 * @returns {string} Formatted plate
 */
export function formatPlate(plate) {
  if (plate == null || typeof plate !== 'string') return '';
  const digits = plate.replace(/\D/g, '');
  if (digits.length === 7) return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
  if (digits.length === 8) return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
  return plate.trim() || '';
}

/**
 * Normalize plate to digits only for storage/comparison.
 * @param {string} plate
 * @returns {string}
 */
export function normalizePlate(plate) {
  if (plate == null || typeof plate !== 'string') return '';
  return plate.replace(/\D/g, '').trim();
}
